(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  (() => {
    const privacyBannerScript = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
    const privacyBannerScriptPath = '/shopifycloud/privacy-banner/storefront-banner.js';
    const privacyActionTimeout = 10000;

    const withTimeout = (promise, timeout, message) => new Promise((resolve, reject) => {
      const timeoutId = window.setTimeout(() => reject(new Error(message)), timeout);

      Promise.resolve(promise).then(resolve, reject).finally(() => {
        window.clearTimeout(timeoutId);
      });
    });

    const privacyBannerApi = () => {
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        return Promise.resolve(window.privacyBanner);
      }

      if (window.bayanPrivacyBannerPromise) return window.bayanPrivacyBannerPromise;

      window.bayanPrivacyBannerPromise = new Promise((resolve, reject) => {
        let script = [...document.scripts].find((candidate) => {
          try {
            return new URL(candidate.src, document.baseURI).pathname === privacyBannerScriptPath;
          } catch (error) {
            return false;
          }
        });
        let appendScript = false;

        if (!script) {
          script = document.createElement('script');
          script.src = privacyBannerScript;
          script.async = true;
          script.dataset.bayanPrivacyBanner = 'true';
          appendScript = true;
        }

        let attempts = 0;
        const removeFailedScript = () => {
          if (script.dataset.bayanPrivacyBanner === 'true') script.remove();
        };
        const stop = () => window.clearInterval(apiCheck);
        const apiCheck = window.setInterval(() => {
          attempts += 1;

          if (typeof window.privacyBanner?.showPreferences === 'function') {
            stop();
            resolve(window.privacyBanner);
          } else if (attempts >= 100) {
            stop();
            removeFailedScript();
            reject(new Error('Shopify privacy preferences API unavailable'));
          }
        }, 100);

        script.addEventListener('error', () => {
          stop();
          removeFailedScript();
          reject(new Error('Shopify privacy preferences script failed to load'));
        }, { once: true });

        if (appendScript) document.head.appendChild(script);
      }).catch((error) => {
        window.bayanPrivacyBannerPromise = undefined;
        throw error;
      });

      return window.bayanPrivacyBannerPromise;
    };

    const openPrivacyPreferences = async (button) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const api = await privacyBannerApi();
        await withTimeout(
          api.showPreferences(),
          privacyActionTimeout,
          'Shopify privacy preferences did not open in time',
        );
      } catch (error) {
        console.error('[BAYAN] Cookie preferences could not be opened.', error);
        const fallback = button.dataset.cookiePreferencesFallback;
        if (fallback) {
          try {
            window.location.assign(fallback);
          } catch (fallbackError) {
            console.error('[BAYAN] Privacy policy fallback could not be opened.', fallbackError);
          }
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    if (!window.bayanCookiePreferencesBound) {
      document.addEventListener('click', (event) => {
        const button = event.target instanceof Element
          ? event.target.closest('[data-cookie-preferences]')
          : null;
        if (!button) return;
        void openPrivacyPreferences(button);
      });
      window.bayanCookiePreferencesBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
